import API from '../api';

export const tradingHistoryList = (params) => API.get(`/api/v1/trading-history?${params}`);

export const getTradingHistoryWT = (params) => API.post('/api/v1/trading-history/orders', params);

export const getTradingHistorySymbols = (logins?: string[]) =>
  API.post('/api/v1/trading-history/symbols', { logins });
